import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//styles
import './document-timeline.scss';

class DocumentTimeline extends React.Component {
  render() {
    const { timeline, currentScreen } = this.props;
    return (
      <div className="document-timeline-wrapper">
        <ul>
          {timeline &&
            timeline.map((item, index) => {
              return (
                <li key={index} className={item.value === currentScreen.value ? 'selected' : ''}>
                  <span>{item.value}</span>
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

DocumentTimeline.propTypes = {
  timeline: PropTypes.array,
  currentScreen: PropTypes.any
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(DocumentTimeline);
